import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHome = location.pathname === "/";
  const isTransparent = isHome && !isScrolled;

  const navBg = isTransparent
    ? "bg-transparent"
    : "bg-background-50/95 backdrop-blur-md border-b border-background-200/60";

  const textColor = isTransparent ? "text-background-50" : "text-foreground-950";
  const textMuted = isTransparent ? "text-background-50/70" : "text-foreground-700";
  const textMutedHover = isTransparent ? "text-background-50" : "text-foreground-950";
  const linkInactive = isTransparent
    ? "text-background-50/70 hover:text-background-50 hover:bg-background-50/10"
    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100";
  const linkActive = isTransparent
    ? "bg-background-50/20 text-background-50"
    : "bg-primary-100 text-primary-700";
  const mobileMenuBg = isTransparent
    ? "bg-foreground-950/95 backdrop-blur-md"
    : "bg-background-50 border-b border-background-200/60";
  const mobileMenuText = isTransparent
    ? "text-background-50/80 hover:text-background-50 hover:bg-background-50/10"
    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100";
  const mobileDivider = isTransparent
    ? "border-background-50/15"
    : "border-background-200/60";
  const mobileAboutText = isTransparent
    ? "text-background-50/60 hover:text-background-50 hover:bg-background-50/10"
    : "text-foreground-600 hover:text-foreground-950 hover:bg-background-100";
  const aboutText = isTransparent
    ? "text-background-50/70 hover:text-background-50"
    : "text-foreground-700 hover:text-foreground-950";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-fill text-background-50 text-lg md:text-xl"></i>
            </div>
            <span className={`text-lg md:text-xl font-bold whitespace-nowrap ${textColor}`}>
              黑料吃瓜
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {categories.map((cat) => {
              const isActive = location.pathname === `/category/${cat.slug}`;
              return (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-3.5 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                    isActive ? linkActive : linkInactive
                  }`}
                >
                  {cat.name}
                </Link>
              );
            })}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${aboutText}`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="lg:hidden w-9 h-9 flex items-center justify-center rounded-lg"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${textColor} ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className={`lg:hidden shadow-lg ${mobileMenuBg}`}>
          <div className="px-4 py-4 space-y-1">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`block px-3 py-2.5 text-sm font-medium rounded-lg transition-colors ${mobileMenuText}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {cat.name}
              </Link>
            ))}
            <div className={`border-t pt-2 mt-2 ${mobileDivider}`}>
              <Link
                to="/about"
                className={`block px-3 py-2.5 text-sm font-medium rounded-lg transition-colors ${mobileAboutText}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                关于我们
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}